<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

html,
body,
#app {
    width: 100%;
}

.ivu-message-notice-content {
    padding: 16px 30px !important;
}

.ivu-message .ivu-icon {
    top: 3px !important;
    font-size: 24px !important;
}

.ivu-message {
    font-size: 15px !important;
}

.ivu-modal-confirm-head-title {
    font-size: 17px !important;
}

.ivu-modal-confirm-body {
    font-size: 15px !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue